<script lang="ts" setup>
import { RouteLocation } from "vue-router";

const props = defineProps<{
  to?: RouteLocation | string;
  href?: string;
  loading?: boolean;
  disabled?: boolean;
}>();

const localePath = useLocalePath();
</script>

<template>
  <a v-if="props.href" :href="props.href">
    <slot />
  </a>
  <NuxtLink v-else-if="props.to" :to="localePath(props.to)">
    <slot />
  </NuxtLink>
  <button v-else :disabled="props.disabled">
    <Icon
      v-if="props.loading"
      class="icon !cursor-wait"
      name="line-md:loading-loop"
    />
    <slot v-else />
  </button>
</template>

<style lang="scss" scoped>
@import "~/assets/scss/_media";

button,
a {
  text-decoration: none;
  font-family: "Gilroy", sans-serif;
  font-weight: 700;
  background-color: var(--color-accent);
  border: none;
  outline: none;
  display: block;
  border-radius: 15px;
  color: #fff;
  padding: 10px 50px;
  font-size: 15px;
  transition: 0.25s background-color ease-in-out;
  width: fit-content;

  @include media("max", "md") {
    padding-inline: 30px;
  }

  &:hover {
    cursor: pointer;
    background-color: var(--color-accent-darker);
  }

  &.outline {
    border: 1px solid var(--color-accent);
    color: var(--color-accent);
    background: transparent;

    &:hover {
      background-color: var(--color-accent);
      color: white;
    }
  }

  &.outline-white {
    border: 1px solid var(--color-light);
    color: var(--color-light);
    background: transparent;

    &:hover {
      background-color: var(--color-light);
      color: var(--color-darker);
    }
  }

  &.danger {
    color: white;
    background: var(--color-error);

    &:hover {
      background-color: var(--color-error-darker);
      color: white;
    }
  }

  &.success {
    background-color: #059669;

    &:hover {
      background-color: #064e3b;
    }
  }
  &.warning {
    background-color: #ffcc49;
    &:hover {
      background-color: #c39c39;
    }
  }
}

button {
  &:disabled {
    background-color: #aeb8f1;
    cursor: auto;
  }
}
</style>
